import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { recipeFiltersSchema } from '@dishly/shared';
import { RecipeList } from '../features/recipes/RecipeList.tsx';

export const Route = createFileRoute('/recipes/')({
  validateSearch: (search) => recipeFiltersSchema.parse(search),
  component: RecipesScreen,
});

function RecipesScreen() {
  const filters = Route.useSearch();
  const navigate = useNavigate({ from: '/recipes/' });
  return (
    <RecipeList
      filters={filters}
      onFilters={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
